import { css, keyframes } from "@emotion/css";

const skeletonLoadingAnimation = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

export const skeletonLoaderCSS = css`
  width: 80%;
  height: 1rem;
  background: linear-gradient(90deg, #adb1b8 25%, #e1e3e7 50%, #adb1b8 75%);
  background-size: 200% 100%;
  animation: ${skeletonLoadingAnimation} 1.5s infinite;
  border-radius: 4px;

  &.step2 {
    width: 60%;
  }

  &.step3 {
    width: 40%;
  }
`;
